/**
 * Theme Store - Gestione tema dark/light
 * Per Gleem Core
 */

import { defineStore } from 'pinia'

export const useThemeStore = defineStore('theme', {
  state: () => ({
    dark: false
  }),
  getters: {
    currentTheme: (state) => state.dark ? 'dark' : 'light'
  },
  actions: {
    init() {
      const savedTheme = localStorage.getItem('gleem.theme')
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
      
      // Priority: 1) Saved preference, 2) System preference, 3) Light default
      this.dark = savedTheme ? savedTheme === 'dark' : prefersDark
      
      this.applyTheme()
      this.watchSystemTheme()
    },
    toggle() {
      this.dark = !this.dark
      localStorage.setItem('gleem.theme', this.dark ? 'dark' : 'light')
      this.applyTheme()
      
      window.dispatchEvent(new CustomEvent('theme-changed', { 
        detail: { theme: this.dark ? 'dark' : 'light' } 
      }))
    },
    setTheme(isDark: boolean) {
      this.dark = isDark
      localStorage.setItem('gleem.theme', isDark ? 'dark' : 'light')
      this.applyTheme()
      
      window.dispatchEvent(new CustomEvent('theme-changed', { 
        detail: { theme: isDark ? 'dark' : 'light' } 
      }))
    },
    applyTheme() {
      document.documentElement.classList.toggle('dark', this.dark)
      document.documentElement.setAttribute('data-theme', this.dark ? 'dark' : 'light')
    },
    watchSystemTheme() {
      const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
      
      const handleChange = (e: MediaQueryListEvent) => {
        if (!localStorage.getItem('gleem.theme')) {
          this.setTheme(e.matches)
        }
      }
      
      if (mediaQuery.addEventListener) {
        mediaQuery.addEventListener('change', handleChange)
      } else {
        mediaQuery.addListener(handleChange)
      }
    }
  }
})




